export const selectInputWhenFocussed =
  (id: string): React.KeyboardEventHandler<HTMLElement> =>
  (event) => {
    if (id) {
      const elem = document.querySelector(`input#${id}`);
      if (event.key === 'Enter' && elem) {
        // @ts-ignore
        elem.click();
      }
    }
  };
